module.exports = __webpack_public_path__ + "img/BOL.ad964a79.svg";